import { Component, HostListener } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { CreateProductComponent } from '../create-product/create-product.component';
import { ProductServiceService } from 'src/app/services/product-service.service';
import { CreateCategoryComponent } from '../create-category/create-category.component';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';
import { TemplateMasterService } from 'src/app/master_modules/masters/apps/template/template-master.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CreateCollectionComponent } from '../create-collection/create-collection.component';
// import { PaginationInstance } from 'ngx-pagination';
import Swal from 'sweetalert2';
import { DeleteProductComponent } from '../delete-product/delete-product.component';
import { DeleteCategoryComponent } from '../delete-category/delete-category.component';
import { DeleteCollectionsComponent } from '../delete-collections/delete-collections.component';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';

@Component({
  selector: 'app-list-products',
  templateUrl: './list-products.component.html',
  styleUrls: ['./list-products.component.scss'],
})
export class ListProductsComponent {
  exportProducts() {

  }
  importProducts() {

  }
  getPlaceholder(): string {
    switch (this.selectedlist) {
      case 'ITEMS':
        return 'Search for products';
      case 'CATEGORIES':
        return 'Search for categories';
      case 'COLLECTIONS':
        return 'Search for collections';
      default:
        return 'Search';
    }
  }

  constructor(
    private productserivice: ProductServiceService,
    private _templateService: TemplateMasterService,
    private snackbar: MatSnackBar,
    private eventService: EventEmmiterService
  ) {
    this.selectCategory(this.activityCategory[0]);
    this.getEcommerceIndustry();
    this.getScreenSize();
  }

  ngOnInit() {
    // If ecomIndustry is already populated, set the first one as the default
    // if (this.ecomIndustry.length > 0) {
    //   this.selectBusinessType(this.ecomIndustry[0]);
    // }
  }
  pageLoader: boolean = false;
  screenWidth: number = 0;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.screenWidth = window.innerWidth;
  }
  selectedlist = 'ITEMS';
  createProduct() {
    // this.pageLoader = true;
    let dialog = this.productserivice.openDialog(
      CreateProductComponent,

      '100vh',
      '45%',
      '80vw',
      { edit: false }
    );

    dialog.afterClosed().subscribe((res: any) => {
      this.getProductList();
    });
  }

  addCategories() {
    if (this.screenWidth > 475) {
      let dialog = this.productserivice.openDialog(
        CreateCategoryComponent,

        '100vh',
        '45%',
        '80vw',
        { edit: false }
      );

      dialog.afterClosed().subscribe((res: any) => {
        this.getCategoriesList();
      });
    }
  }
  createCollection() {
    if (this.screenWidth > 475) {
      let dialog = this.productserivice.openDialog(
        CreateCollectionComponent,

        '100vh',
        '45%',
        '80vw',
        { edit: false }
      );

      dialog.afterClosed().subscribe((res: any) => {
        // this.getCategoriesList();
        this.getCollectionList();
      });
    }
  }
  addCollection() { }
  activityCategory = [
    { value: 'ITEMS', viewValue: 'Products', status: 'true' },
    { value: 'CATEGORIES', viewValue: 'Categories', status: 'true' },
    // { value: "DELETED", viewValue: "Deleted", status: "true" },
    { value: 'COLLECTIONS', viewValue: 'Collections', status: 'true' },
  ];

  selectCategory(element: any) {
    // this.dataSource = [];
    this.pageNo = 0;
    this.pageLoader = true;
    this.activityCategory.forEach((item: any) => {
      if (item.value === element.value) {
        item.status = true;
        this.selectedlist = item.value;
      } else {
        item.status = false;
      }
    });
    if (this.selectedlist == 'ITEMS') {
      this.getProductList();
    } else if (this.selectedlist == 'CATEGORIES') {
      this.getCategoriesList();
    } else if (this.selectedlist == 'COLLECTIONS') {
      this.getCollectionList();
    }
  }
  pageNo: number = 0;
  size: number = 10000;
  totalCount: number = 0;
  isLoading = false;
  mathCount
  public totalPages: number = 0;
  getProductList() {
    this.pageLoader = true;
    this.displayedColumns = [
      'productImage',
      'name',
      'contactNumber',
      'sellingPrice',
      'maturityAmount',
      'installment',
      'Action',
    ];
    let data: any = {
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    if (this.subCategoryId && this.subCategoryId.length > 0) {
      data.subId = this.subCategoryId;
    }
    this.productserivice.getProductList(data).subscribe({
      next: (res: any) => {
        this.dataSource = res.data.data;
        this.totalCount = res.data.total;
        this.mathCount = Math.ceil(this.totalCount / this.size);
        this.config.totalItems = res.data.total;
        this.config.itemsPerPage = this.size;
        this.config.currentPage = this.pageNo;
        this.eventService.updateTitle.emit({ key: 'Product', count: `${res.data.total}` });
        this.pageLoader = false;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }
  displayedColumns: string[] = [];
  itemsdisplayedColumns: string[] = [
    'name',
    'contactNumber',
    'sellingPrice',
    'description',
  ];
  onSearchChange(type){
    switch(type){
      case 'ITEMS':
        this.searchProductItems();
        return;
      case 'CATEGORIES':
        this.searchcategorieslist();
        return
      case 'COLLECTIONS':
        this.searchCollection();
        return
      default:
        this.searchProductItems();
    }
    
  }
  loadMoreStates() {
    if (this.isLoading) return; // prevent multiple calls
    if ((this.pageNo + 1) * this.size >= this.totalCount) return; // no more data

    this.isLoading = true;
    this.pageNo += 1;

    if (this.selectedlist === 'ITEMS') {
      this.loadMoreProducts();
    } else if (this.selectedlist === 'CATEGORIES') {
      this.loadMoreCategories();
    } else if (this.selectedlist === 'COLLECTIONS') {
      this.loadMoreCollections();
    }
  }
  loadMoreProducts() {
    let data = {
      pageNo: this.pageNo,
      pageSize: this.size,
      subId: this.subCategoryId
    };
    this.productserivice.getProductList(data).subscribe({
      next: (res: any) => {
        this.dataSource = [...this.dataSource, ...res.data.data];
        this.totalCount = res.data.total;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        this.productserivice.openSnack(err.error.message, 'close');
      }
    });
  }

  loadMoreCategories() {
    let data = {
      pageNo: this.pageNo,
      pageSize: this.size,
      subId: this.subCategoryId
    };
    this.productserivice.getCategoriesList(data).subscribe({
      next: (res: any) => {
        this.dataSource = [...this.dataSource, ...res.data.data];
        this.totalCount = res.data.total;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        this.productserivice.openSnack(err.error.message, 'close');
      }
    });
  }

  loadMoreCollections() {
    let data = {
      pageNo: this.pageNo,
      pageSize: this.size,
      subId: this.subCategoryId
    };
    this.productserivice.getCollectionList(data).subscribe({
      next: (res: any) => {
        this.dataSource = [...this.dataSource, ...res.data.data];
        this.totalCount = res.data.total;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        this.productserivice.openSnack(err.error.message, 'close');
      }
    });
  }


  getCategoriesList() {
    this.pageLoader = true;
    this.displayedColumns = ['Category', 'description', 'Status'];

    let data: any = {
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    if (this.subCategoryId && this.subCategoryId.length > 0) {
      data.subId = this.subCategoryId;
    }
    this.productserivice.getCategoriesList(data).subscribe({
      next: (res: any) => {
        this.pageLoader = false;
        this.dataSource = res.data.data;
        this.totalCount = res.data.total;
        this.mathCount = Math.ceil(this.totalCount / this.size);
        this.config.totalItems = res.data.total;
        this.config.itemsPerPage = this.size;
        this.config.currentPage = this.pageNo;
        this.eventService.updateTitle.emit({ count: `${res.data.total}` });
        this.pageLoader = false;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }

  getCollectionList() {
    this.pageLoader = true;
    this.displayedColumns = [
      'Collection',
      'collectionDescription',
      'collectionStatus',
    ];
    let data: any = {
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    if (this.subCategoryId && this.subCategoryId.length > 0) {
      data.subId = this.subCategoryId;
    }
    this.productserivice.getCollectionList(data).subscribe({
      next: (res: any) => {
        this.pageLoader = false;
        this.dataSource = res.data.data;
        this.totalCount = res.data.total;
        this.mathCount = Math.ceil(this.totalCount / this.size);
        this.config.totalItems = res.data.total;
        this.eventService.updateTitle.emit({ count: `${res.data.total}` });
        this.config.itemsPerPage = this.size;
        this.config.currentPage = this.pageNo;
        this.pageLoader = false;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }

  searchText: any;
  searchCategoriesText: any = '';
  searchCollectionText: any = '';
  viewAccess: boolean = true;
  itemDataSource: any = [];

  searchProductItems(type: boolean = false) {
    if (this.searchText.length == 0) {
      this.getProductList();
    }
    if (this.searchText.length >= 2) {
      this.pageNo = type ? this.pageNo : 0;
      this.searchDataProducts();
    }
  }

  searchDataProducts() {
    let data = {
      subId: this.subCategoryId,
      searchText: this.searchText,
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    this.productserivice.getProductList(data).subscribe({
      next: (res: any) => {
        this.dataSource = res.data.data;
        this.totalPages = Math.ceil(res.data.total / this.size);
        this.config.currentPage = this.pageNo;
        this.config.totalItems = res.data.total;
        this.config.itemsPerPage = this.size;
        this.totalCount = res.data.total;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }
  searchcategorieslist(type: boolean = false) {
    if (this.searchCategoriesText.length == 0) {
      this.getCategoriesList();
    }
    if (this.searchCategoriesText.length >= 2) {
      this.pageNo = type ? this.pageNo : 0;
      this.searchDataCategories();
    }
  }
  searchDataCategories() {
    let data = {
      subId: this.subCategoryId,
      searchText: this.searchCategoriesText,
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    this.productserivice.getCategoriesList(data).subscribe({
      next: (res: any) => {
        this.dataSource = res.data.data;
        this.totalPages = Math.ceil(res.data.total / this.size);
        this.config.currentPage = this.pageNo;
        this.config.totalItems = res.data.total;
        this.config.itemsPerPage = this.size;
        this.totalCount = res.data.total;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }

  searchCollection(type: boolean = false) {
    if (this.searchCollectionText.length == 0) {
      this.getCollectionList();
    }
    if (this.searchCollectionText.length >= 2) {
      this.pageNo = type ? this.pageNo : 0;
      this.searchCollentionData();
    }
  }

  searchCollentionData() {
    let data = {
      subId: this.subCategoryId,
      searchText: this.searchCollectionText,
      pageNo: this.pageNo,
      pageSize: this.size,
    };
    this.productserivice.getCollectionList(data).subscribe({
      next: (res: any) => {
        this.dataSource = res.data.data;
        this.totalPages = Math.ceil(res.data.total / this.size);
        this.config.currentPage = this.pageNo;
        this.config.totalItems = res.data.total;
        this.config.itemsPerPage = this.size;
        this.totalCount = res.data.total;
      },
      error: (err: any) => {
        this.pageLoader = false;
        this.productserivice.openSnack(err.error.message, 'close');
        this.dataSource = [];
      },
    });
  }
  dataSource: any = [];
  id: any = 'custom';
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0,
  };
  editProduct(item: any) {
    let dialog = this.productserivice.openDialog(
      CreateProductComponent,

      '100vh',
      '45%',
      '80vw',
      { edit: true, data: item }
    );

    dialog.afterClosed().subscribe((res: any) => {
      this.getProductList();
    });
  }
  deleteProduct(stateId: string) {
    let dialog = this.productserivice.openDeleteDialog(
      DeleteProductComponent,
      '250px',
      '350px',
      { data: stateId },
      '80vw'
    );
    dialog.afterClosed().subscribe((data: any) => {
      if (!data) return;
      this.getProductList();
    });
  }

  editCategories(item: any) {
    if (this.screenWidth > 475) {
      let dialog = this.productserivice.openDialog(
        CreateCategoryComponent,
        '100vh',
        '45%',
        '80vw',
        { edit: true, data: item }
      );
      dialog.afterClosed().subscribe((res: any) => {
        this.getCategoriesList();
      });
    }
  }
  deleteCategories(stateId: any) {
    let dialog = this.productserivice.openDeleteDialog(
      DeleteCategoryComponent,
      '250px',
      '350px',
      { data: stateId },
      '80vw'
    );
    dialog.afterClosed().subscribe((data: any) => {
      if (!data) return;
      this.getCategoriesList();
    });
  }
  editCollection(item: any) {
    if (this.screenWidth > 475) {
      let dialog = this.productserivice.openDialog(
        CreateCollectionComponent,
        '100vh',
        '45%',
        '80vw',
        { edit: true, data: item }
      );
      dialog.afterClosed().subscribe((res: any) => {
        this.getCollectionList();
      });
    }
  }
  deleteCollection(stateId: any) {
    let dialog = this.productserivice.openDeleteDialog(
      DeleteCollectionsComponent,
      '250px',
      '350px',
      { data: stateId },
      '80vw'
    );
    dialog.afterClosed().subscribe((data: any) => {
      if (!data) return;
      this.getCollectionList();
    });


  }
  ecomIndustry: any = [];
  subCategoryId: any = '';
  bType: any;
  ecomMyControl = new FormControl('ALL');
  ecomFilteredOptions: Observable<string[]> | any;
  getVal(ev) {
    if (ev.length === 0) {
      this.bType = '';
    }
  }
  activeTab: String = '';
  selectBusinessType(ev: any) {
    this.bType = ev;
    if (this.bType != 'ALL')
      this.subCategoryId = ev.subIndustryId;
    else
      this.subCategoryId = '';
    if (this.selectedlist == 'ITEMS') {
      this.getProductList();
    } else if (this.selectedlist == 'CATEGORIES') {
      this.getCategoriesList();
    } else if (this.selectedlist == 'COLLECTIONS') {
      this.getCollectionList();
    }
  }
  getEcommerceIndustry() {
    this._templateService.getAllEcommerceIndustries().subscribe(
      (res: any) => {
        this.ecomFilteredOptions = this.ecomMyControl;
        res.data.forEach((data: any) => {
          this.ecomIndustry.push({
            name: data.name,
            industryId: data.parent.id,
            subIndustryId: data.id,
            industryName: data.parent.name,
            subIndustryName: data.name,
          });
        });
        this.filteredEcomIndustry = [...this.ecomIndustry];
        // if (this.ecomIndustry.length > 0) {
        //   const defaultOption = this.ecomIndustry[0];
        //   this.ecomMyControl.setValue(defaultOption); // Set the whole object now
        //   this.selectBusinessType(defaultOption);
        // }
        this.ecomFilteredOptions = this.ecomMyControl.valueChanges.pipe(
          startWith(''),
          map((value) => this._ecomFilter(value))
        );
      },
      (err) => {
        this.snackbar.open(`${err.error.message}`, 'Close');
      }
    );
  }
  private _ecomFilter(value: any) {
    const filterValue = value.toLowerCase();

    return this.ecomIndustry.filter((option: any) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  getProductListByCategorie(element: any) {
    let data = {
      categoryId: element.categoryId,
    };
    this.productserivice.getProductListByCategorie(data.categoryId).subscribe({
      next: (res: any) => {
        this.itemDataSource = res.data[0].categoryItems;
      },
    });
  }
  // loadBusinessTypes() {
  //   this.productserivice.getBusinessTypes().subscribe((res: any) => {
  //     this.ecomOptions = res.data;
  //     this.ecomFilteredOptions = this.ecomOptions;
  //   });
  // }
  filterEcomIndustry() {
    const searchText = this.searchEcom.toLowerCase();
    this.filteredEcomIndustry = this.ecomIndustry.filter((option) =>
      option.name.toLowerCase().includes(searchText)
    );
  }

  searchEcom: string = '';
  filteredEcomIndustry: any[] = [];
  clearSearchAndClose(select: any) {
    this.searchEcom = '';
    this.filterEcomIndustry();
    select.close(); // closes the dropdown
  }
  pageChanged(ev: any) {
    // console.log("event",ev);
    this.pageNo = ev - 1; // assuming backend expects 0-based indexing
    // this.getProductList();
    if (this.selectedlist == 'ITEMS') {
      this.getProductList();
    } else if (this.selectedlist == 'CATEGORIES') {
      this.getCategoriesList();
    } else if (this.selectedlist == 'COLLECTIONS') {
      this.getCollectionList();
    }

    // this.pageNo=2;
    // this.size=10;
    // this.getAllStoresWithPagination();
  }
  // pageClick(ev: any) {
  //   console.log('Page clicked:', ev);
  //   this.pageNo = ev - 1; // Update page number (zero-based index)
  // }
  get totalPageCount(): number {
    const itemsPerPage: number = 10;
    return Math.ceil(this.totalCount / itemsPerPage);
  }

  nextClicked() {
    const totalPages = Math.ceil(this.totalCount / this.size);
    if (this.pageNo + 1 >= totalPages) {
      this.snackbar.open('You are on the last page', 'Ok', { duration: 1500 });
    } else {
      this.pageChanged(this.pageNo + 2); // +2 because `ev - 1` logic inside
    }
  }


  previousClicked() {
    if (this.pageNo === 0) {
      this.snackbar.open('You are on the first page', 'Ok', { duration: 1500 });
    } else {
      this.pageChanged(this.pageNo); // one less than current (ev - 1 in method)
    }
  }



}  
